import React from 'react';
import './App.css';
import { Sequence } from './Sequence';
import { ToolBar } from './ToolBar';

export const App: React.FC = () => {
  return (
    <div className="App"
      onContextMenu={e => e.preventDefault()}
      onDragStart={e => e.preventDefault()}
      onWheel={e => e.ctrlKey && e.preventDefault()}
    >
      <ToolBar />
      <Sequence />
    </div>
  );
}
